// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___BkM_m","overlayModal":"style__overlayModal___A0Qvh","overlayModalInner":"style__overlayModalInner___Xq7IO","overlayCloseButton":"style__overlayCloseButton___1o4L1","overlayModalTitle":"style__overlayModalTitle___2zYYD","overlayModalText":"style__overlayModalText___1EyMp","overlayModalTextBold":"style__overlayModalTextBold___GJ5fQ","overlayModalButtons":"style__overlayModalButtons___QsahC","overlayModalButtonsItem":"style__overlayModalButtonsItem___S8_tk","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___3hfXn","buttonActive":"style__buttonActive___2_lu7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-vip/style.css
// module id = 1289
// module chunks = 0